import { render, staticRenderFns } from "./servicos-regionalizados.vue?vue&type=template&id=9d682f52&scoped=true&"
import script from "./servicos-regionalizados.vue?vue&type=script&lang=js&"
export * from "./servicos-regionalizados.vue?vue&type=script&lang=js&"
import style0 from "./servicos-regionalizados.vue?vue&type=style&index=0&id=9d682f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d682f52",
  null
  
)

export default component.exports